import { render } from "./VisionMission.vue?vue&type=template&id=c2982bc6&ts=true"
import script from "./VisionMission.vue?vue&type=script&lang=ts"
export * from "./VisionMission.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__